import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createBlock(_component_UiPanel, {
    class: "w-full",
    "no-padding": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "containerRef",
        class: "w-full",
        style: _normalizeStyle({ height: $setup.props.height })
      }, [
        ($setup.isReady)
          ? (_openBlock(), _createBlock($setup["VChart"], {
              key: 0,
              class: "h-full w-full",
              option: $setup.props.option,
              autoresize: $setup.props.autoresize,
              "update-options": { notMerge: true },
              onMouseover: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('mouseover', $event))),
              onMouseout: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('mouseout', $event))),
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.emit('click', $event)))
            }, null, 8 /* PROPS */, ["option", "autoresize"]))
          : _createCommentVNode("v-if", true)
      ], 4 /* STYLE */)
    ]),
    _: 1 /* STABLE */
  }))
}